import { useState } from 'react';

import { useApiAccess } from 'contexts/AccessProvider';
import {
  useGmpMessagesDetailsQuery,
  useSubmitGatewayTaskDetailsQuery,
  useTaskDetailsQuery,
} from 'gql';
import { useLocation, useParams } from 'react-router-dom';

import GMPMessageData from './components/GMPMessageData';
import ReadTaskData from './components/ReadTaskData';
import SubmitGatewayEventData from './components/SubmitGatewayEventData';

const VisibleFieldByPhase = {
  submitted: 21,
  Sign: 21,
  Write: 20,
  Read: 20,
} as const;

type VisibleFieldKeys = keyof typeof VisibleFieldByPhase;

const getFieldValue = (field: VisibleFieldKeys) => {
  return VisibleFieldByPhase[field];
};

const useGMPDetails = () => {
  const { id } = useParams();
  const { sessionKey } = useApiAccess();
  const [seeMore, setSeeMore] = useState(false);
  const { pathname, state } = useLocation();
  const isReadTask = pathname.includes('task');
  const isSubmitGateway = pathname.includes('submit-gateway');
  const isGmpMessage = pathname.includes('message');

  const task = id?.startsWith('0x') ? { messageId: id as string } : { taskId: Number(id) };

  const {
    data: taskDetailsData,
    loading: isLoading,
    error,
  } = useTaskDetailsQuery({
    variables: { sessionKey, ...task },
    skip: isSubmitGateway || isGmpMessage,
  });

  const { data: gmpMessageDetailsData, loading: isGmpMessageDetailsLoading } =
    useGmpMessagesDetailsQuery({
      variables: { sessionKey, messageId: id as string },
      skip: isReadTask || isSubmitGateway,
    });

  const { data: submitGatewayTaskDetailsData, loading: isSubmitGatewayTaskDetailsLoading } =
    useSubmitGatewayTaskDetailsQuery({
      variables: {
        sessionKey,
        batchId: !state?.isTaskId ? Number(id) : undefined,
        taskId: state?.isTaskId ? Number(id) : undefined,
      },
      skip: isReadTask || isGmpMessage,
    });

  const taskData = ReadTaskData({ taskDetailsData });
  const gmpMessageData = GMPMessageData({ gmpMessageDetailsData });
  const submitGatewayTaskData = SubmitGatewayEventData({ submitGatewayTaskDetailsData });
  const title = isReadTask
    ? 'Read Task Info'
    : isGmpMessage
    ? 'GMP Message Info'
    : 'Submit Gateway Task Info';
  return {
    taskData: taskData.slice(
      0,
      seeMore
        ? taskData.length
        : getFieldValue(taskDetailsData?.taskDetails?.phase as VisibleFieldKeys)
    ),
    gmpMessageData,
    isGmpMessageDetailsLoading,
    submitGatewayTaskData,
    isSubmitGatewayTaskDetailsLoading,
    title,
    isLoading,
    id: taskDetailsData?.taskDetails.taskId || taskDetailsData?.taskDetails.id,
    error,
    seeMore,
    setSeeMore,
  };
};
export default useGMPDetails;
